<p-rating (ngModelChange)="ratingValue($event)" [stars]="noOfStars" [cancel]="false" [readonly]="readonly" [disabled]="disabled" [ngModel]="starCount">
</p-rating>
